import React,{useEffect, useRef, useState, useContext, createContext} from 'react';
import createComponent from '@services/react-mount-component';
import {subscribe} from '@services/events';
import globeVisualization from './globe-visualization';

const MarkerContext = createContext();

const MarkerProvider = ({
  markers = [],
  ...props
})=>{
  const markerState = useState(markers);
  const defaultItem = markers.find(({isDefault})=>isDefault);
  const selectedIndex = markers.indexOf(defaultItem) || 0;
  const selectedIndexState = useState(selectedIndex);

  useEffect(()=>{
    markerState[1](markers);
    selectedIndexState[1](selectedIndex);
  },[markers,selectedIndex]);

  return (<MarkerContext.Provider {...props} value={{markerState,selectedIndexState}} />);
}

const useMarkers = ()=>{
  const [markers,setMarkers] = useContext(MarkerContext).markerState;
  const [selectedIndex,setSelectedIndex] = useContext(MarkerContext).selectedIndexState;
  return {
    markers,
    selectedIndex,
    setMarkers,
    setSelectedIndex,
    previous(){
      setSelectedIndex(
        selectedIndex > 0 ? selectedIndex - 1 : markers.length - 1
      )
    },
    next(){
      setSelectedIndex(
        selectedIndex < markers.length - 1 ? selectedIndex + 1 : 0
      )
    },
  };
}

const Globe = ()=>{
  const canvas = useRef();
  const globeRef = useRef();
  const {markers,selectedIndex} = useMarkers();

  useEffect(()=>{
    globeRef.current = globeVisualization(canvas.current);

    const {current:globe} = globeRef;
    globe.markers = markers;
    globe.selectedIndex = selectedIndex;

    const offsetListener = subscribe(canvas.current.parentNode,'sections:offsetchange',e=>{
      globe.offset = e.detail.offset;
    });

    return ()=>{
      offsetListener();
      globe.destroy();
    }
  },[]);

  useEffect(()=>{
    const {current:globe} = globeRef;
    globe.markers = markers;
  },[markers]);

  useEffect(()=>{
    const {current:globe} = globeRef;
    globe.selectedIndex = selectedIndex;
  },[selectedIndex]);

  return (
    <canvas ref={canvas} />
  )
}

const LocationSelect = ()=>{
  let {markers,selectedIndex,setSelectedIndex} = useMarkers();
  const [open,setOpen] = useState(false);
  const [height,setHeight] = useState(0);
  const itemsRef = useRef();

  const updateHeight = ()=>{
    if(!itemsRef.current) return;
    const target = itemsRef.current;
    if(target) setHeight(target.getBoundingClientRect().height);
  }
  useEffect(updateHeight,[markers,selectedIndex]);

  return (
    <div className="location-select has-wheel" style={{'--selected-index':selectedIndex}}>
      <div className="current-item" onClick={e=>setOpen(!open)} >
        <ul>
          {markers.map(({title},index)=>(
            <li key={index} className={index===selectedIndex ? 'active' : ''}>
              {title}
            </li>
          ))}
        </ul>
      </div>
      <div className="controls" onClick={e=>setOpen(!open)}>
        <button />
      </div>
      <div className={`${open?'is-open':''} items-dropdown`} style={{'--height':`${height}px`}}>
          <ul ref={itemsRef}>
            {markers.map(({title},index)=>(
              <li key={index} className={index===selectedIndex ? 'active' : ''}>
                <button onClick={e=>{setOpen(false);setSelectedIndex(index)}}>{title}</button>
              </li>
            ))}
          </ul>
      </div>
    </div>
  )
}

const GlobeDescriptions = ()=>{
  let {markers,selectedIndex} = useMarkers();
  const [height,setHeight] = useState(0);
  const itemsRef = useRef();


  const updateHeight = ()=>{
    if(!itemsRef.current) return;
    const target = itemsRef.current.children[selectedIndex+1];
    if(target) setHeight(target.getBoundingClientRect().height);
  }

  useEffect(updateHeight,[markers,selectedIndex]);

  return (
    <div className="globe-descriptions content" style={{'--current-index':selectedIndex}}>
      <div ref={itemsRef} style={{'--active-height':`${height}px`}}>
        {
          markers.map((marker,index) => (
            <div key={index} className={index===selectedIndex?'description-content active':'description-content'} dangerouslySetInnerHTML={{__html:marker.description}} style={{'--index':index+1}} />
          ))
        }
      </div>
    </div>
  )
}

const Content = ({fallbackContent,title})=>{
  return (
    <div className="container">
      <div className="globe-content-wrap columns content-type-gridelements_pi1 content-layout-0   ">
        <div className="column is-4 is-offset-1">
          <div className="content-type-text content-layout-0 ">
            <header>
              <h2>
                {title}
                <div className="redline" />
              </h2>
              <h3>
                <LocationSelect />
              </h3>
            </header>
            <GlobeDescriptions fallbackContent={fallbackContent} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default createComponent(
  '.globe',
  ({title,content,items=[]})=>{
    return (
      <MarkerProvider markers={items}>
        {window.innerWidth >= 768 && <Globe />}
        <Content fallbackContent={content} title={title} />
      </MarkerProvider>
    )
  }
)